// OrderBookAnt.jsx
import React, { useState } from "react";
import { Table, Select, Button } from "antd";
import { AppstoreOutlined, BarsOutlined } from "@ant-design/icons";
import { L1, L3, L4 } from "../SvgCollections";
import "./orderbook-ant.css";

const { Option } = Select;

const dummySellData = [...Array(15)].map((_, i) => ({
    key: i,
    price: (84550 + i * 2.5).toFixed(2),
    qty: (Math.random() * 0.05).toFixed(4),
    total: (Math.random() * 3000 + 1000).toFixed(2),
}));

const dummyBuyData = [...Array(15)].map((_, i) => ({
    key: i,
    price: (84540 - i * 2.5).toFixed(2),
    qty: (Math.random() * 0.05).toFixed(4),
    total: (Math.random() * 3000 + 1000).toFixed(2),
}));

function OrderBookPanel({ orderbook }) {
    const [activeMode, setActiveMode] = useState(0);
    const [depthValue, setDepthValue] = useState(2);

    const sellColumns = [
        {
            title: "Price(USDT)",
            dataIndex: "price",
            align: "left",
            render: (v, record) => {
                const [price, qty] = record;
                return <span className="sell-color">{parseFloat(price)}</span>
            },
        },
        {
            title: "Qty", dataIndex: "qty", align: "right", render: (v, record) => {
                const [price, qty] = record;
                return <span className="sell-color">{parseFloat(Number(qty).toFixed(4))}</span>
            }
        },
        {
            title: "Total(USDT)", dataIndex: "total", align: "right", render: (v, record) => {
                const [price, qty] = record;
                return <span className="sell-color">{parseFloat(Number(price * qty).toFixed(4))}</span>
            }
        },
    ];

    const buyColumns = [
        {
            title: "Price(USDT)",
            dataIndex: "price",
            align: "left",
            render: (v, record) => {
                const [price, qty] = record;
                return <span className="buy-color">{parseFloat(price)}</span>
            },
        },
        {
            title: "Qty", dataIndex: "qty", align: "right", render: (v, record) => {
                const [price, qty] = record;
                return <span className="buy-color">{parseFloat(Number(qty).toFixed(4))}</span>
            },
        },
        {
            title: "Total(USDT)", dataIndex: "total", align: "right", render: (v, record) => {
                const [price, qty] = record;
                return <span className="buy-color">{parseFloat(Number(price * qty).toFixed(4))}</span>
            },
        },
    ];

    const showSell = activeMode === 0 || activeMode === 2;
    const showBuy = activeMode === 0 || activeMode === 3;

    return (
        <div className="orderbook-wrapper">
             {/* Header title buttons */}
            <div className="header-row">
                <div className="title-book">Order Book</div>
               
            </div>
            {/* Top Tabs & Depth */}
            <div className="orderbook-top">
                <div className="icon-tabs">
                    <div
                        className={`tab-icon ${activeMode === 0 ? "active" : ""}`}
                        onClick={() => setActiveMode(0)}
                    >
                        <L1 />
                    </div>
                    <div
                        className={`tab-icon ${activeMode === 2 ? "active" : ""}`}
                        onClick={() => setActiveMode(2)}
                    >
                        <L4 />
                    </div>
                    <div
                        className={`tab-icon ${activeMode === 3 ? "active" : ""}`}
                        onClick={() => setActiveMode(3)}
                    >
                        <L3 />
                    </div>
                </div>

                <Select
                    size="small"
                    value={depthValue}
                    style={{ width: 80 }}
                    onChange={(v) => setDepthValue(v)}
                    className="tab-book"
                >
                    <Option value={2}>0.01</Option>
                    <Option value={3}>0.001</Option>
                    <Option value={4}>0.0001</Option>
                </Select>
            </div>

           
            <div className="orderbook-wrapper-full">
                {/* SELL SIDE */}
                {showSell && (
                    <div className={activeMode === 2 ? "sell-box-full" : "sell-box"}>
                        <Table
                            size="small"
                            pagination={false}
                            sticky
                            columns={sellColumns}
                            scroll={{ y: "100%", x: "100%" }}
                            dataSource={orderbook?.bids || []}
                            className="obtable"
                        />
                    </div>
                )}

                {/* MID PRICE / SPREAD */}
                {/* {activeMode === 0 && (
                    <div className="mid-row">
                        <span className="mid-price">84544.20</span>
                        <span className="spread">Spread: 30.05</span>
                    </div>
                )} */}

                {/* BUY SIDE */}
                {showBuy && (
                    <div className={activeMode === 3 ? "buy-box-full" : "buy-box"}>

                        <Table
                            size="small"
                            pagination={false}
                            sticky
                            columns={buyColumns}
                            dataSource={orderbook?.asks || []}
                            className="obtable"
                            scroll={{ y: "100%", x: "100%" }}

                        />
                    </div>
                )}
            </div>
        </div>
    );
}

export default OrderBookPanel;
